module.exports = __webpack_public_path__ + "img/1.2456d4ad.jpg";